// extracted by mini-css-extract-plugin
export default {"product":"cartProduct_product__dGpbv","left":"cartProduct_left__Be-T2","right":"cartProduct_right__u4F43"};